// extracted by mini-css-extract-plugin
export default {"button":"button_button__W4auM","box":"button_box__x5D4s","processing":"button_processing__BM0tO","animate":"button_animate__963KH","disabled":"button_disabled__qtAVP"};